import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "history-menu--sprite",
  "use": "history-menu--sprite-usage",
  "viewBox": "0 0 18 12",
  "content": "<symbol viewBox=\"0 0 18 12\" xmlns=\"http://www.w3.org/2000/svg\" id=\"history-menu--sprite\">\n<path d=\"M0.75 11.5H12.6667V9.66667H0.75V11.5ZM0.75 6.91667H9.91667V5.08333H0.75V6.91667ZM0.75 0.5V2.33333H12.6667V0.5H0.75ZM17.25 9.29083L13.9683 6L17.25 2.70917L15.9575 1.41667L11.3742 6L15.9575 10.5833L17.25 9.29083Z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol